import { defaultFetch, fetchWithAuth } from "../utils/auth";

export const confirmAttendanceByIdOrToken = async (tokenOrbookingInterestId: string | number, acceptedRelatedBookingInterestIds: number[]): Promise<any> => {
    try {
        const fetchUrl = `/api/backend/attendance/confirm/${tokenOrbookingInterestId}`
        let res;

        if (typeof tokenOrbookingInterestId === 'string') {
            res = await defaultFetch(fetchUrl, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(acceptedRelatedBookingInterestIds)
            });
        } else {
            res = await fetchWithAuth(fetchUrl, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(acceptedRelatedBookingInterestIds)
            });
        }

        if (res.status >= 400 && res.status < 600) {
            const resText = await res.text();
            console.warn(resText);
            throw new Error("Server not returned a valid response");
        }

        const resJson = await res.json();
        return resJson
    } catch (error) {
        let message = 'Unable to delete session';

        if (error instanceof Error) {
            message = error.message;
        }

        return { error: message };
    }
}

export const declineAttendanceByIdOrToken = async (tokenOrbookingInterestId: string | number): Promise<any> => {
    try {
        const fetchUrl = `/api/backend/attendance/decline/${tokenOrbookingInterestId}`
        let res;

        if (typeof tokenOrbookingInterestId === 'string') {
            res = await defaultFetch(fetchUrl, {
                method: 'POST',
            });
        } else {
            res = await fetchWithAuth(fetchUrl, {
                method: 'POST',
            });
        }
        if (res.status >= 400 && res.status < 600) {
            const resText = await res.text();
            console.warn(resText);
            throw new Error("Server not returned a valid response");
        }

        const resJson = await res.json();
        return resJson
    } catch (error) {
        let message = 'Unable to delete session';

        if (error instanceof Error) {
            message = error.message;
        }

        return { error: message };
    }
}